import ApplicationSerializer from './application';

export default class UserDocumentTemplateSerializer extends ApplicationSerializer {
  modelNameFromPayloadKey(key: string): string {
    if (key === 'default-user-document-templates') {
      return 'user-document-template';
    }

    return super.modelNameFromPayloadKey(key);
  }
}
